import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isFunction from "lodash/isFunction";
import "regenerator-runtime/runtime.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.define-property.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Form, Row, Col, Input, Button, Dropdown, CheckboxSwitch, DateTimePicker, showSuccess } from 'components';
import { getCurrencyConfig, showApiError } from 'utils';
import { externalCreditTypeNameSelect, externalCreditStatusNameSelect, EXTERNAL_CREDIT_TYPE, borrowerTypeNameSelect, currencyNameSelect, dateFormat2 } from 'enums';
import { createExternalCredit, updateExternalCredit } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var formatDateField = function formatDateField(value) {
  return moment(value).isValid() ? moment(value).format(dateFormat2) : value;
};

var sectionStyle = function sectionStyle(theme) {
  return {
    padding: '1.5em 0',
    borderBottom: "1px solid ".concat(theme.gray100),
    '&:first-of-type': {
      paddingTop: 0
    },
    '&:last-of-type': {
      borderBottom: 'none',
      paddingBottom: 0
    }
  };
};

var sectionTitle = function sectionTitle(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.6em',
    marginBottom: '1.4em',
    '& i': {
      fontSize: '1.6rem',
      color: theme.primary
    },
    '& h5': {
      fontSize: '1.35rem',
      fontWeight: 600,
      color: theme.gray800,
      margin: 0
    }
  };
};

var ExternalCreditDataForm = function ExternalCreditDataForm(_ref) {
  var _getCurrencyConfig;

  var data = _ref.data,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit;

  var initialFormData = _objectSpread({
    currency: (_getCurrencyConfig = getCurrencyConfig()) === null || _getCurrencyConfig === void 0 ? void 0 : _getCurrencyConfig.defaultCurrency,
    type: EXTERNAL_CREDIT_TYPE.external,
    in_ckr: false,
    debt_assignment: false
  }, data);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var values, formattedValues, method, params, _yield$method, _yield$method2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              values = _ref2.values;
              formattedValues = _objectSpread(_objectSpread({}, values), {}, {
                date: formatDateField(values.date),
                next_principal_payment_date: formatDateField(values.next_principal_payment_date),
                next_interest_payment_date: formatDateField(values.next_interest_payment_date),
                last_payment_date: values.last_payment_date ? formatDateField(values.last_payment_date) : null
              });
              method = data ? updateExternalCredit : createExternalCredit;
              params = data ? [data === null || data === void 0 ? void 0 : data.id, _objectSpread(_objectSpread({}, data), formattedValues)] : [formattedValues];
              _context.next = 6;
              return method.apply(void 0, params);

            case 6:
              _yield$method = _context.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 12:
              showSuccess("\u0412\u044A\u043D\u0448\u043D\u0438\u044F\u0442 \u043A\u0440\u0435\u0434\u0438\u0442 ".concat(data ? 'редактиран' : 'създаден', " \u0443\u0441\u043F\u0435\u0448\u043D\u043E."));
              _isFunction(onSubmit) && onSubmit(res);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: initialFormData
  }, ___EmotionJSX("div", {
    css: sectionStyle
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "fas fa-file-contract"
  }), ___EmotionJSX("h5", null, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "type",
    label: "\u0422\u0438\u043F \u043A\u0440\u0435\u0434\u0438\u0442",
    options: externalCreditTypeNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "currency",
    label: "\u0412\u0430\u043B\u0443\u0442\u0430",
    options: currencyNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "number",
    label: "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "status",
    label: "\u0421\u0442\u0430\u0442\u0443\u0441",
    options: externalCreditStatusNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(CheckboxSwitch, {
    label: "\u0412 \u0426\u041A\u0420",
    formId: "in_ckr"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(CheckboxSwitch, {
    label: "\u0426\u0435\u0441\u0438\u044F",
    formId: "debt_assignment"
  })))), ___EmotionJSX("div", {
    css: sectionStyle
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "fas fa-user"
  }), ___EmotionJSX("h5", null, "\u041A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "borrower_name",
    label: "\u0418\u043C\u0435 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "borrower_type",
    label: "\u0422\u0438\u043F \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B",
    options: borrowerTypeNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "borrower_identifier",
    label: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 (\u0415\u0413\u041D/\u0415\u0418\u041A)",
    required: true
  })))), ___EmotionJSX("div", {
    css: sectionStyle
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "fas fa-coins"
  }), ___EmotionJSX("h5", null, "\u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "amount",
    label: "\u0421\u0443\u043C\u0430",
    number: true,
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "payed",
    label: "\u041F\u043B\u0430\u0442\u0435\u043D\u043E",
    number: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "interest_percent",
    label: "\u041B\u0438\u0445\u0432\u0435\u043D \u043F\u0440\u043E\u0446\u0435\u043D\u0442 (%)",
    number: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "gpr",
    label: "\u0413\u041F\u0420 (%)",
    number: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "period_months",
    label: "\u041F\u0435\u0440\u0438\u043E\u0434 (\u043C\u0435\u0441\u0435\u0446\u0438)",
    number: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "gratis_period",
    label: "\u0413\u0440\u0430\u0442\u0438\u0441\u0435\u043D \u043F\u0435\u0440\u0438\u043E\u0434 (\u043C\u0435\u0441\u0435\u0446\u0438)",
    number: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "monthly_payment_amount",
    label: "\u041C\u0435\u0441\u0435\u0447\u043D\u0430 \u0432\u043D\u043E\u0441\u043A\u0430",
    number: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "future_interest",
    label: "\u0411\u044A\u0434\u0435\u0449\u0430 \u043B\u0438\u0445\u0432\u0430",
    number: true
  })))), ___EmotionJSX("div", {
    css: sectionStyle
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "fas fa-calendar-alt"
  }), ___EmotionJSX("h5", null, "\u0414\u0430\u0442\u0438 \u0438 \u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(DateTimePicker, {
    required: true,
    formId: "date",
    label: "\u0414\u0430\u0442\u0430 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    timeFormat: false,
    dateFormat: dateFormat2,
    inputProps: {
      placeholder: 'Дата на кредита'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(DateTimePicker, {
    required: true,
    formId: "next_principal_payment_date",
    label: "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0430 \u0434\u0430\u0442\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435 \u0433\u043B\u0430\u0432\u043D\u0438\u0446\u0430",
    timeFormat: false,
    dateFormat: dateFormat2,
    inputProps: {
      placeholder: 'Следваща дата плащане главница'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(DateTimePicker, {
    required: true,
    formId: "next_interest_payment_date",
    label: "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0430 \u0434\u0430\u0442\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435 \u043B\u0438\u0445\u0432\u0430",
    timeFormat: false,
    dateFormat: dateFormat2,
    inputProps: {
      placeholder: 'Следваща дата плащане лихва'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(DateTimePicker, {
    formId: "last_payment_date",
    label: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u043F\u043B\u0430\u0449\u0430\u043D\u0435",
    timeFormat: false,
    dateFormat: dateFormat2,
    inputProps: {
      placeholder: 'Дата последно плащане'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "last_payment_amount",
    label: "\u0421\u0443\u043C\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u043F\u043B\u0430\u0449\u0430\u043D\u0435",
    number: true
  })))), ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end",
    margin: "1.5em 0 0 0"
  }, function (_ref4) {
    var onSubmit = _ref4.onSubmit;
    return ___EmotionJSX(React.Fragment, null, _isFunction(onClose) && ___EmotionJSX(Button, {
      type: "secondary",
      onClick: onClose,
      margin: "0 1em 0 0"
    }, "\u041D\u0430\u0437\u0430\u0434"), ___EmotionJSX(Button, {
      onClick: onSubmit
    }, "\u0417\u0430\u043F\u0430\u0437\u0438"));
  }));
};

ExternalCreditDataForm.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  data: PropTypes.object
};
export default ExternalCreditDataForm;